import React from 'react';
import { Wrench, Coffee, Scissors, Hammer, Users, Hotel } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function ResultsSection() {
  const industries = [{
    icon: <Wrench className="w-8 h-8 text-[#c9a84c]" data-id="element-580" />,
    title: 'Plumbers & Electricians',
    desc: 'In Dublin and across Ireland'
  }, {
    icon: <Coffee className="w-8 h-8 text-[#c9a84c]" data-id="element-581" />,
    title: 'Cafés & Restaurants',
    desc: 'Local dining spots nationwide'
  }, {
    icon: <Scissors className="w-8 h-8 text-[#c9a84c]" data-id="element-582" />,
    title: 'Barbers & Salons',
    desc: 'Hair and beauty professionals'
  }, {
    icon: <Hammer className="w-8 h-8 text-[#c9a84c]" data-id="element-583" />,
    title: 'Local Trades',
    desc: 'Builders, roofers, and contractors'
  }, {
    icon: <Users className="w-8 h-8 text-[#c9a84c]" data-id="element-584" />,
    title: 'Coaches & Consultants',
    desc: 'Professional service providers'
  }, {
    icon: <Hotel className="w-8 h-8 text-[#c9a84c]" data-id="element-585" />,
    title: 'Hotels & B&Bs',
    desc: 'Accommodation across Ireland'
  }];
  return <section id="who-this-is-for" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-586">
      <div className="max-w-6xl mx-auto" data-id="element-587">
        <div className="text-center mb-16 reveal" data-id="element-588">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-589">
            Built for Irish Small Businesses
          </h2>
          <p className="text-white/70 max-w-3xl mx-auto leading-relaxed text-lg" data-id="element-590">
            A strong website helps Irish businesses get found on Google, build
            trust with local customers, and convert visitors into leads. Whether
            you serve Dublin 8 or all of Ireland, your website is your 24/7
            salesperson.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-591">
          {industries.map((item, idx) => <div key={idx} className="premium-card p-6 rounded-xl flex items-start space-x-4 reveal" style={{
          transitionDelay: `${idx * 100}ms`,
          backgroundColor: '#0a0a0a',
          border: '1px solid rgba(255,255,255,0.06)'
        }} data-id="element-592">
              <div className="bg-[#c9a84c]/10 w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-593">
                {item.icon}
              </div>
              <div data-id="element-594">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-595">
                  {item.title}
                </h3>
                <p className="text-white/50 text-sm" data-id="element-596">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
      <SectionDivider data-id="element-597" />
    </section>;
}